import { OrderStatusResponseDto, OrderResponseDto } from '@data/data/models/order-status.dto';
import { SendEmailResponseDto } from '@data/data/models/send-invoice.dto';
import { OrderEntity } from '@data/domain/order-detail.entity';
import { ITEM } from '@utils/constants';

export class OrderDetailMapper {
  mapFromOrderStatus(dto: OrderStatusResponseDto): OrderEntity {

    const {
      transactionId,
      title,
      bankName,
      redirectUrl,
      total,
      status
    } = dto.data;

    const {
      name,
      price,
      quota,
      validity,
      billingCycle,
      subTotal,
      transactionFee,
      emailSended
    } = dto.data.detail;

    return new OrderEntity(
      transactionId,
      title,
      bankName,
      redirectUrl,
      total,
      status,
      name,
      price,
      quota,
      validity,
      billingCycle,
      subTotal,
      transactionFee,
      emailSended,
      '',
      ''
    );

  }

  mapFromOrder(dto: OrderResponseDto): OrderEntity {

    const {
      transactionId,
      paymentMethod,
      bankName,
      paymentCode,
      checkoutUrl,
      status,
      totalAmount,
      timeRemaining
    } = dto.data;

    return new OrderEntity(
      transactionId,
      paymentMethod,
      bankName,
      checkoutUrl,
      totalAmount,
      status,
      '',
      ITEM.DEFAULT_VALUE,
      '',
      '',
      '',
      ITEM.DEFAULT_VALUE,
      ITEM.DEFAULT_VALUE,
      false,
      paymentCode,
      timeRemaining
    );
  }

  mapFromEmailResponse(dto: SendEmailResponseDto): { transactionId: string } {
    return {
      transactionId: dto.data.transactionId ?? ''
    };
  }
}
